/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadItemsDetails(itemList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/getItems`, itemList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createItemDetails(itemList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/createitem`, itemList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updateItemDetails(itemList) {
  // let payload = { isMode:2 }

  return await api
    .put(`/org/updateitem`, itemList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deleteItemDetails(itemList) {
  // let payload = { isMode:2 }

  return await api
    .post(`/org/deleteitem`, itemList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//Category

export async function loadCategoryDetails(categoryList) {
  return await api
    .post(`/org/getcategory`, categoryList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadStockDetails(stockDetails) {
  return await api
    .post(`/org/getstockdetails`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadStockValueDetails(stockDetails) {
  return await api
    .post(`/org/getstockvalue`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPartyWiseDetails(partyList) {
  return await api
    .post(`/org/getpartywisereport`, partyList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createCategoryDetails(categoryList) {
  return await api
    .post(`/org/createcategory`, categoryList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function adjustStockDetails(stockList) {
  return await api
    .post(`/org/adjuststock`, stockList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadItemsDetails,
  createItemDetails,
  loadStockValueDetails,
  loadCategoryDetails,
  createCategoryDetails,
  loadStockDetails,
  loadPartyWiseDetails,
  adjustStockDetails,
  loadRecordsMetaData,
  updateItemDetails,
  deleteItemDetails,
};

export default remotes;
